.container {
  display: flex;
  flex-wrap: wrap;
  flex: 100%;
  gap: 8px;
  list-style-type: none;
}

.item {
  color: light-dark(var(--brand-grey-400), var(--brand-grey-200));
  font-size: var(--font-size-sm);
}

.item:not(:last-of-type):after {
  content: '•';
  margin-left: 8px;
  color: var(--brand-grey-200);
}
